import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useManageSubjects() {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function addSubjects(data) {
    return privateFetch.post(`/v1/admin/subject`, data);
  }

  function updateSubjects({ id: subjectID, ...rest } = {}) {
    return privateFetch.put(`/v1/admin/subject/${subjectID}`, rest);
  }

  function manageSubjects(data) {
    if (data.id) return updateSubjects(data);

    return addSubjects(data);
  }

  return useMutation(manageSubjects, {
    onSuccess() {},
    onError() {},
    onSettled() {
      queryClient.invalidateQueries('subjects');
    },
  });
}

export default useManageSubjects;
